import { render, staticRenderFns } from "./Herramienta.vue?vue&type=template&id=8387226e&"
import script from "./Herramienta.vue?vue&type=script&lang=js&"
export * from "./Herramienta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports